import { Group } from '@mantine/core';
import styled from 'styled-components';

export const GroupContainer = styled(Group).attrs({ position: 'apart', px: 'sm', py: 'xs' })`
	border-bottom: 1px solid ${(props) => props.theme.v2.color.neutral[300]};
	width: 100%;
	justify-content: flex-end;
`;

export const DocumentWrapper = styled.div`
	padding: 1rem;
	height: 100%;
`;

export const ScrollArea = styled.div`
	flex: 1 1 auto;
	min-height: 0;
	overflow-y: visible;
`;

export const Main = styled.div`
	display: flex;
	gap: 2rem;
	width: 100%;
	height: 100%;
	overflow: auto;
`;
export const MainContent = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	max-width: 100%;
	height: 100%;
	padding-bottom: 1rem;
`;
